import { render, staticRenderFns } from "./EditBalanceDialog.vue?vue&type=template&id=4bd1e0e3&scoped=true"
import script from "./EditBalanceDialog.vue?vue&type=script&lang=js"
export * from "./EditBalanceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditBalanceDialog.vue?vue&type=style&index=0&id=4bd1e0e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1e0e3",
  null
  
)

export default component.exports